export enum EVisitDocumentMetaData {
  PILOTE_CERTIFICATE_TYPE = 'pilotCertificateType',
  MEDICAL_AUTHORITY = 'medicalAuthority',
  EXPIRATION_DATE = 'expirationDate',
  EXAMINATION_DATE = 'examinationDate'
}
